import { Button } from "@/components/ui/button";
import { Facebook, Twitter, Linkedin, Link2 } from "lucide-react";
import { toast } from "sonner";
import { CalculationResults } from "@/types/calculator";

interface SocialShareProps {
  results: CalculationResults;
  shareUrl: string;
}

const SocialShare = ({ results, shareUrl }: SocialShareProps) => {
  const shareText = `I'm using this Walking Weight Loss Calculator to plan my fitness journey! ${Math.round(results.weeklyCalories)} kcal/week burn. Check it out:`;
  
  const handleFacebookShare = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
    toast.success("Opening Facebook share...");
  };

  const handleTwitterShare = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
    toast.success("Opening Twitter share...");
  };

  const handleLinkedInShare = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
    toast.success("Opening LinkedIn share...");
  };

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(shareUrl);
    toast.success("Link copied to clipboard!");
  };

  return (
    <div className="flex flex-wrap gap-3 justify-center md:justify-start">
      <Button
        variant="outline"
        size="default"
        onClick={handleFacebookShare}
        className="gap-2 min-w-[44px] min-h-[44px] px-4"
        aria-label="Share on Facebook"
      >
        <Facebook className="w-5 h-5 text-[#1877F2]" />
        <span className="sr-only sm:not-sr-only">Facebook</span>
      </Button>
      
      <Button
        variant="outline"
        size="default"
        onClick={handleTwitterShare}
        className="gap-2 min-w-[44px] min-h-[44px] px-4"
        aria-label="Share on Twitter"
      >
        <Twitter className="w-5 h-5 text-[#1DA1F2]" />
        <span className="sr-only sm:not-sr-only">Twitter</span>
      </Button>
      
      <Button
        variant="outline"
        size="default"
        onClick={handleLinkedInShare}
        className="gap-2 min-w-[44px] min-h-[44px] px-4"
        aria-label="Share on LinkedIn"
      >
        <Linkedin className="w-5 h-5 text-[#0A66C2]" />
        <span className="sr-only sm:not-sr-only">LinkedIn</span>
      </Button>
      
      <Button
        variant="outline"
        size="default"
        onClick={handleCopyLink}
        className="gap-2 min-w-[44px] min-h-[44px] px-4"
        aria-label="Copy link to clipboard"
      >
        <Link2 className="w-5 h-5" />
        <span className="sr-only sm:not-sr-only">Copy Link</span>
      </Button>
    </div>
  );
};

export default SocialShare;
